import Swal from 'sweetalert2';

const baseOptions = {
  confirmButtonColor: '#2E6A29',
  cancelButtonColor: '#b43737',
  reverseButtons: true,
  customClass: {
    popup: 'portal-swal',
    confirmButton: 'portal-swal-confirm',
    cancelButton: 'portal-swal-cancel',
  },
  buttonsStyling: false,
};

export function confirmDialog({ title, text, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar' }) {
  return Swal.fire({
    ...baseOptions,
    icon: 'warning',
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  });
}

export function successAlert({ title, text }) {
  return Swal.fire({
    ...baseOptions,
    icon: 'success',
    title,
    text,
    confirmButtonText: 'Fechar',
  });
}

export function errorAlert({ title, text }) {
  return Swal.fire({
    ...baseOptions,
    icon: 'error',
    title,
    text,
    confirmButtonText: 'Fechar',
  });
}

// ---------------------------------------------------------------------------
// Erro contado na ordem em que a pessoa lê.
//
//   1. TÍTULO  — o que houve, em poucas palavras que ela entenda de relance
//   2. TEXTO   — o que fazer a respeito
//   3. RODAPÉ  — o detalhe técnico, miúdo, pra TI
//
// O erro chega primeiro em quem está atendendo, e é ela quem manda o print.
// Um "Erro" com "[Evolution] enviar mensagem em caixa-e-crediario-ef: ...
// (HTTP 400)" no corpo vira chamado; "Esse número não tem WhatsApp" com o que
// fazer embaixo se resolve sozinho — e o detalhe continua ali pra chegar em nós
// quando precisar.
// ---------------------------------------------------------------------------

// Restos técnicos que já vazaram pra tela antes de a API separar os campos.
function limparTecniques(texto) {
  return String(texto || '')
    .replace(/^\[[^\]]+\]\s*/, '')          // "[Evolution] ..."
    .replace(/\s*\(HTTP \d{3}\)\s*$/i, '')  // "... (HTTP 400)"
    .trim();
}

// Título quando quem chamou não deu um. Nunca "Erro" pelado: é a primeira
// coisa lida e não informa nada.
function tituloAutomatico(texto, status) {
  const t = String(texto || '').toLowerCase();
  if (t.includes('não tem whatsapp')) return 'Esse número não tem WhatsApp';
  if (t.includes('desconectado') || t.includes('reconecte')) return 'O WhatsApp está desconectado';
  if (t.includes('não respondeu a tempo')) return 'O WhatsApp demorou a responder';
  if (status === 403) return 'Você não tem acesso a isso';
  if (status === 404) return 'Não encontramos esse item';
  if (status === 409) return 'Alguém chegou antes';
  if (status >= 500) return 'O sistema falhou aqui';
  return 'Não deu pra concluir';
}

// Erro SEM resposta: o pedido saiu e nada voltou. Não é "erro do sistema" — o
// servidor nunca chegou a opinar. Merece texto próprio porque o conselho é
// outro (olhar o sinal, não chamar a TI) e porque o genérico escondia isso:
// em 28/08/2026 um envio de foto de 4 MB morreu no meio e o atendente leu
// "Tente de novo; se continuar, chame a TI" com "Network Error" no rodapé —
// nada ali dizia que a conexão tinha caído.
function semResposta(err) {
  const codigo = String(err?.code || '');
  const msg = String(err?.message || '');
  if (codigo === 'ECONNABORTED' || /timeout/i.test(msg)) {
    return {
      titulo: 'Demorou demais e foi cancelado',
      texto: 'A internet pode estar lenta. Espere um instante e tente de novo.',
    };
  }
  if (codigo === 'ERR_NETWORK' || /network error/i.test(msg)) {
    return {
      titulo: 'A conexão caiu no meio',
      texto: 'Não chegou resposta do servidor. Confira o sinal e tente de novo — o que você digitou continua aqui.',
    };
  }
  return null;
}

/** Camadas prontas a partir de um erro do axios. */
export function explicarErro(err, titulo) {
  const resp = err?.response;
  const dados = resp?.data || {};
  const rede = !resp ? semResposta(err) : null;
  const texto = limparTecniques(dados.message)
    || rede?.texto
    || 'Tente de novo; se continuar, chame a TI.';
  const tecnico = dados.tecnico || err?.message || (resp?.status ? `HTTP ${resp.status}` : null);
  // O título de quem chamou vence, mas se ele for o genérico do envio e a causa
  // for a conexão, o específico informa mais — "Não deu pra enviar" não diz por
  // quê, "A conexão caiu no meio" diz.
  return {
    titulo: rede?.titulo || titulo || tituloAutomatico(texto, resp?.status),
    texto,
    tecnico,
  };
}

/** Mostra o erro no padrão da casa. Use SEMPRE isto em vez de montar o Swal. */
export function alertarErro(err, titulo) {
  const e = explicarErro(err, titulo);
  return Swal.fire({
    ...baseOptions,
    icon: 'error',
    title: e.titulo,
    text: e.texto,
    footer: e.tecnico
      ? `<span style="font-size:.72rem;opacity:.55">Detalhes para a TI: ${e.tecnico}</span>`
      : undefined,
    confirmButtonText: 'Entendi',
  });
}
